import { useState, useEffect } from 'react'

/**
 * Custom hook for mobile detection with responsive breakpoint
 */
export const useMobileDetection = (breakpoint: number = 768) => {
	const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint)

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < breakpoint)
		}

		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [breakpoint])

	return isMobile
}